import axios from 'axios';

const API_URL = process.env.REACT_APP_API_SERVER_DEV || 'http://localhost:8000';
const API_KEY = process.env.REACT_APP_API_KEY;

const axiosClient = axios.create({
  baseURL: `${API_URL}/api/v1`, 
});

axiosClient.interceptors.request.use((config) => {
  config.headers['X-API-KEY'] = API_KEY;
  return config;
});

export default axiosClient;